<template>
    <div>
        <breadcrumb :routerList="[{to:'/chanp/companyPriceManage',title:'价格管理(客户)列表'},{title:'定价信息'}]"/>
         <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom:0.3rem">
                                    <h1>基本信息</h1>
                                </div>
                                <div class="h-pieceCon2">
                                	<div class="h-formLine weekplandetail14">
                                		<el-form :model="zy" label-position="right" ref="zy" :inline="true" class="demo-ruleForm h-formbLine h-formbLine1">
                                        <el-form-item label="经销商名称" class="h-elformWrap-2" prop="agentName">
                                            <el-input v-model="zy.agentName" placeholder="请输入" readonly>
                                            </el-input>
                                        </el-form-item>
                                        <el-form-item label="经销商编码" class="h-elformWrap-2" prop="agentCode">
                                            <el-input placeholder="选择经销商自动带出" v-model="zy.agentCode" readonly></el-input>
                                        </el-form-item>
                                        <el-form-item label="销售区域" class="h-elformWrap-2" prop="salesregionName">
                                            <el-input placeholder="选择经销商自动带出" v-model="zy.salesregionName" readonly></el-input>
                                        </el-form-item>

                                        <el-form-item label="直单附件" class="h-elformWrap-2" prop="upload" v-if="!isHsjOrKs">
                                            <brupload
                                                :refid="zy.fileid"
                                                reftype="代理商注册-附件"
                                                :showtime="false">
                                            </brupload>
                                        </el-form-item>

                                        <el-form-item label="附件" class="h-elformWrap-2" prop="upload1" v-if="!isHsjOrKs">
                                            <brupload
                                                :refid="zy.kehufujian"
                                                reftype="客户定价-附件"
                                                :showtime="false">
                                            </brupload>
                                        </el-form-item>

                                     </el-form>


                                	</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="h-rowBox ljjtablepaddings4" style="margin-top:30px;padding:0;">
                        <div class="h-rowCon" style="padding-bottom:0">
                            <div class="h-pieceIn2" style="padding-left:0.26rem;">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;display: flex;justify-content: space-between;align-items: center;">
                                    <h1>定价信息 <br>
                                    </h1>
                                </div>
                            </div>
                            <el-table
                                ref="multipleTable"
                                :data="tableData3"
                                style="width: 100%"
                                stripe
                                border
                            >
                              <el-table-column
                                  type="index"
                                  width="40"
                                  label="#">
                              </el-table-column>
                                <el-table-column
                                    prop="leixing"
                                    min-width="170"
                                    label="定价类型"
                                    >
                                    <template slot-scope="scope">
                                        <el-select class="h-tableInput" v-model="scope.row.leixing" style="width: 100%;" placeholder="请选择" @change="changejibiequyu(scope.row)" :disabled="true" :class="{'ljj_selectdisblednone2':true}" >
                                            <el-option  v-for="(item) in dingjialeixing"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="materialCode"
                                    label="物料编码"
                                    :show-overflow-tooltip="true"
                                    width="180">
                                </el-table-column>
                                <el-table-column
                                    prop="materialDescrition"
                                    label="物料名称"
                                    :show-overflow-tooltip="true"
                                    width="180">
                                </el-table-column>
                                <el-table-column
                                prop="currency"
                                min-width="170"
                                label="币种">
                                    <template slot-scope="scope" >
                                        <el-select  class="h-tableInput" :class="{'ljj_selectdisblednone2':true}" v-model="scope.row.currency" style="width: 100%;" :disabled="true" >
                                            <el-option v-for="item in bizhongListops" :key="item.code"
                                                       :label="item.name" :value="item.code" :disabled="scope.row.leixing==1" >
                                            </el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                  prop="value"
                                  min-width="120"
                                  label="价格">
                                  <template slot-scope="scope">
                                  <div style="text-align: right;">{{scope.row.value}}</div>
                                  </template>
                                </el-table-column>

                                <el-table-column
                                    prop="prodseries"
                                    label="大类名称"
                                    :show-overflow-tooltip="true"
                                    width="100">
                                </el-table-column>
                              <el-table-column
                                        prop="youxiaoqi"
                                        min-width="300"
                                        label="有效期">
                                    <template slot-scope="scope">
										                  <div>{{scope.row.youxiaoqi[0]}}至{{scope.row.youxiaoqi[1]}}</div>
                                    </template>
                              </el-table-column>

                            </el-table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="h-table h-mrt30 h-rowBox" style="margin-top:0.8rem">
                <div class="h-pieceTitle2 hang">
                    <h1 class="h1" style="margin-left:20px">定价审批</h1>
                    <el-form :model="dingjiashenpi" label-position="right" :inline="true"
                            class="demo-ruleForm h-formbLine ">
                        <el-form-item label="审批意见" class="h-elformWrap-2 w-elformWrap-3" :required="true" style="margin-top:0.2rem;margin-left: 0.2rem;">
                            <el-input v-model="dingjiashenpi.shenheyijian" placeholder="请输入"
                                      :disabled="taskstatus==1" ></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

             <div class="h-txtCenter" style="margin-top: 0.3rem;">
                 <el-button class="h-btn h-bBtn h-bgwhite" @click="quxiaoanniu">返回</el-button>
                 <el-button class="h-btn h-bBtn h-bgred" @click="tongguobohui(1)" v-if="taskstatus==0">驳回</el-button>
                 <el-button class="h-btn h-bBtn h-bggreen" @click="tongguobohui(2)"  v-if="taskstatus==0">通过</el-button>
                 <el-button class="h-btn h-bBtn" @click="viewpress">审批跟踪</el-button>
             </div>
             <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
        </div>
    </div>
</template>
<script>
import ss from '../../api/SystemService';
export default {
    data(){
        let that=this
        return{

            bizhongListops:[],
            oemTableData: [],
            taskstatus:'',
            showhistory:false,
            isOemProduct: false,
            materialOemCode: '',
            serviceProductsType:'',
            //物料id
            ywid:'',
            //taskid
            taskid:'',
            Headquarters:'',
            refuseDialog:true,
            //流程id
            instid:'',
            liuchengid:'',
            xuanzeliuchengop:[],
            rules: {
                shenheyijian: [
                    { required: true, message: '不能为空', trigger: 'blur' },
                ],

            },
            show:true,

            dingjiashenpi:{
                shenheyijian:'',
            },
            bianlianga:'',

            q: {
                pageSize: 100,
                pageNo: 1,
                total: 0,
            },
            //币种
            bizhonglist:[],
            //区域
            YlSalesArea:[],
            //前页转发内容
            chanpinneirong:{},
            //定价id
            dingjiaid:'',
            dingjialeixing: [{
                value: '',
                label: '--请选择--'
            },{
                value: 2,
                label: '外贸'
            },{
                value: 1,
                label: '内销'
            }, {
                value: 0,
                label: '外销'
            }],
            jibie: [{
                value: '',
                label: '--请选择--'
            },],
            quyu: [{
                value: '',
                label: '--请选择--'
            },],
            //配置集合
            configlist:{},
            bizhongop:[{
                value: '',
                label: '--请选择--'
            },],
            all: "全部",
            formInline:{
				names:'',
                starttime: '',
                endtime:'',
                areaName:''
            },
			options1:[{
			    value: '选项1',
			    label: '渠道1'
			    }, {
			    value: '选项2',
			    label: '渠道2'
			    }],
            pickerOptions:{
                disabledDate(time){
                    let endDate=that.formInline.endtime;
                    let startDate=that.formInline.starttime;
                    return time.getTime()<new Date(startDate).getTime() || time.getTime()>=new Date(endDate).getTime()
                }
            },
            options2:[],
			      zy: {
                agentName:null,
                agentCode:null,
                salesregion:null,
                salesregionName:null,
                fileid: null,
            },
            //选中的
            selectedList: [],
            tableData3: [
                {
                    leixing:'',
                    jibie: '',
                    currency: '',
                    value: '',
                    youxiaoqi: ['',''],

                }
            ],
            optionsCustomer:[],
            optionsAgent:[],
            userCarePlan:{},


            bizhong:null,
            fwProdcut:{
                productName:null,
                productId:null,
                currency:null,
                unitPrice:null,
                customerName:null,
                customerCode:null,
            },
            isHsjOrKs: false, //物料是海盛杰或者康盛
        }
    },
    mounted(){

    },
    created(){


        this.bizhongjiazai();

        this.options2 = this.$store.getters.dicts["userCareType"];

        //业务id
        this.ywid = this.$router.history.current.query.ywid;

        //taskid
        this.taskid = this.$router.history.current.query.taskid;

        this.taskstatus = this.$route.query.taskstatus;

        //instid
        this.instid = this.$router.history.current.query.instid;

        console.log(this.$route.query,'为什么')


        this.chushixuanze(this.$router.history.current.query.ywid);



    },
    methods:{


        //币种加载
        bizhongjiazai(){
            ss.Dictservice.listbycategory("YLCurrency").then(rd=>{
                console.log(rd,'字典结果')
                this.bizhongListops = rd;
            })
        },
        viewpress(){
            this.showhistory = true;
        },
        //选没选值
        xuanmeixuanzhi(done){
            this.$confirm('确认关闭？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				})
                .then(_ => {
                    if(!this.instid){
                        this.$msg.msge('请先选择')
                        console.log('请先选择')
                    }else{
                        done();
                    }
                })
                .catch(_ => {

                });
        },
        //选择流程，将被选中流程id存起来
        fuzhi(){
            this.instid = this.liuchengid;
            console.log(this.liuchengid)
        },
        //关闭选择框加载数据

        hidden(index){
            if(index === 6){
                this.show = fasle;
            }
        },

        //初始选择流程
        chushixuanze(q){
            var shenpibanben = {
                shenpibanben:q,
            }
            ss.companyPrice.getliucheng(shenpibanben).then(rd => {
              console.log("rd",rd)
                //物料上部信息

                this.zy.agentName = rd.obj[0].agentName,
                this.zy.agentCode = rd.obj[0].agentCode,
                this.zy.salesregion = rd.obj[0].salesregion,
                this.zy.salesregionName = rd.obj[0].salesregionName,
                this.zy.fileid = rd.obj[0].fileid
                this.zy.kehufujian = rd.obj[0].kehufujian

                //如果是海盛杰或者康盛的产品
                if(rd.obj[0].noHsjKs){
                    this.isHsjOrKs = false;
                }else{
                    this.isHsjOrKs = true;
                }
              this.q.total = rd.total;
              this.jiazaibiao(rd.obj);


            })
        },

        //加载表
        jiazaibiao(q){

            this.tableData3 = [];

            for(var y in q){

                var list =  {

                    leixing: q[y].leltypecode==1?'经销商':'',
                    materialCode: q[y].materialCode,//物料编码
                    materialDescrition: q[y].materialDescrition,//物料描述
                    currency: q[y].currency,//币种
                    value: q[y].value,//定价金额
                    oneLid: q[y].oneLid,//大类编码
                    prodseries :q[y].prodseries,//大类名称
                    protype :q[y].protype,//产品类型
                    leixingflag: q[y].leltypecode,//类型的flag
                    id: q[y].id,//定价id主键
                    youxiaoqi: [q[y].startdate,q[y].effectivedate],//定价有效期

                    ispass:q[y].ispass,//审核标志   0 未通过   1 通过   2暂存  3提交审核中

                }

                this.tableData3.push(list)

            }

        },



        //更换级别区域
        changejibiequyu(q){

            console.log(q,'看看是多少')

             this.jiazaijibiequyu(q);

        },

        //取消
        quxiao(){
            this.$router.go(-1);
        },



        handleSelectionChange(val) {

            console.log(val)
            this.selectedList = val;
        },


        //更换数据字典名
        jiazaijibiequyu(q){

            if(q.leixing == 1){//todo  级别配置？？
                q.bianlianga='';//todo 级别配置的数据字典？？？
                q.leixingflag=1;

            }

        },


        //取消按钮
        quxiaoanniu(){
            this.$router.go(-1);

        },

        tongguobohui(q){

            var shenPiEntity = {
                yewuzhujian: this.ywid,//业务主键
                taskid: this.taskid,//页面拿到的taskid
                msg: this.dingjiashenpi.shenheyijian,//  页面填写的审核意见
                jiediantiaojianming:'tongguoorbohui',//通过还是驳回的节点条件名字
                instid:this.instid,//选择要进入的审批版本id
                shifouquantongguo:'1',//是否全操作flag   0否  1是
            }
            // 通过还是驳回的flag  1驳回  2通过
            if(q==1){
                shenPiEntity.tongguoorbohui=1;
                shenPiEntity.optflag = '驳回';
                if (!this.dingjiashenpi.shenheyijian) {
                  this.$msg.msge("驳回必须输入审批意见！");
                  return;
                }

            }else if(q==2){
                shenPiEntity.tongguoorbohui=2;
                shenPiEntity.optflag = '通过';
            }
            ss.companyPrice.companySetPrice(shenPiEntity).then(rd => {
                if(rd.f==true){

                    this.$msg.alerts("提交成功！",()=>{
                        //刷新右上角的代办个数
                        this.$store.dispatch("searchTasktotal")
                        this.$router.go(-1);
                    })
                }
            })
        },


    },
}
</script>
<style scoped>
   .bbbb {
        padding-top: 5px;
    }
    .hang {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }
</style>
<style>
    .weekplandetail14 .h-formbLine .el-form-item__label {
        width: 35%;
        text-align: right;
    }

    .weekplandetail14 .h-formbLine .el-form-item__content {
        width: 65%;
    }

    .weekplandetail14 .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }
    .el-table .warning-row {
        background:#fef0f0;
    }

    .el-table .success-row {
        background: #f0f9eb;
    }

	.ljjtablepaddings4 .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.w-elformWrap-3 {
		width: 100% !important;
	}
	.w-elformWrap-3 .el-form-item__label {
		width: 8% !important;
	}
	.w-elformWrap-3 .el-form-item__content {
		width: 92% !important;
	}
	.ljjtablepaddings4 .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}
	.ljjtablepaddings4 .el-range-editor.is-disabled{
		background-color: transparent;
		border-color: transparent;
	}
	.ljjtablepaddings4 .el-table tbody td .cell{
		padding: 0.03rem 0.1rem;
	}

	.ljj_selectdisblednone2 .el-input.is-disabled .el-input__inner{
		border-color: transparent;
	}
	.ljj_selectdisblednone2.el-select .el-input.is-disabled .el-input__inner:hover{
		border-color: transparent;
	}
	.ljj_selectdisblednone2 .el-input__suffix{
		display: none;
	}
</style>

